
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { jobLocationSelector } from "slices/jobLocationSlice";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/jobLocationSlice";
import { removeMultipleJobLocations } from "slices/jobLocationSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";
import AddJobLocation from "components/JobLocation/AddJobLocation";
import { fetchJobLocations } from "slices/jobLocationSlice";
import { convertTimeToUTCFormatted } from "helpers/convertTimeToUTC";

const apiService = new Api();

function JobLocationsList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { jobLocations, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(jobLocationSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  React.useEffect(() => {
    dispatch(fetchJobLocations())
  }, [])

  const handleAddLocationPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchJobLocations())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleJobLocations({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(jobLocations?.map((jobLocation) => jobLocation.id.toString()))


  }

  const handleClose = () => {
    refAddutton.current.click(); setAddForm({ show: false })
  };

  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchJobLocations(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }

    return (
      <tr>
        <th className="col-2">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Job Locations') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th className="col-4">
          <TableHeaderItem
            title="Job Location Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-4">
          <TableHeaderItem
            title="POETA"
            sortBy="poeta"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-4">
          <TableHeaderItem
            title="Court Type"
            sortBy="court_type_name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="By Zoom"
            sortBy="by_zoom"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="Location Address"
            sortBy="address"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Job Locations') &&
          <th >Status</th>
        }
        {checkPermission('Edit Job Locations') &&
          <th >Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      jobLocations?.map((jobLocation, index) => (
        <JobLocationsItems jobLocation={jobLocation} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddLocationPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [jobLocations, selectedItems]);

  //#endregion


  return (
    <ListLayout
      heading="Job Locations"
      time={true}
      title=""
      buttonTitle="Add location"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      // TODO: change loation permission with currect keyword 
      addButtonDisabled={!checkPermission('Create Job Locations')}
      totalPages={totalPages}
      fetchList={fetchJobLocations}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddJobLocation item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Cities')} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddLocationPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search location..."
      noOfItems={total}

    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const JobLocationsItems = ({
  jobLocation, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(jobLocation?.status);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }

  React.useEffect(() => {
    setStatus(jobLocation?.status)

  }, [jobLocation])

  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Job Locations') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={jobLocation.id} checked={selectedItems.includes(jobLocation.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {jobLocation.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {jobLocation?.poeta?.org}
      </td>
      <td style={getBackgroundStyle(status)}>
        {jobLocation?.court_type?.court_type_name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {jobLocation.by_zoom ? "Yes" : "No"}
      </td>
      <td style={getBackgroundStyle(status)}>
        {jobLocation.address || '-'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {convertTimeToUTCFormatted(jobLocation.created_at)}
      </td>
      {checkPermission('Status Job Locations') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(jobLocation?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      {checkPermission('Edit Job Locations') &&
        <td style={getBackgroundStyle(status)}>
          <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...jobLocation, status })}>Edit</button>
        </td>
      }
    </tr>
  )
}


export default JobLocationsList;
